// extracted by css-extract-rspack-plugin
export default {"back":"CalculatorBack-module__back--iZPPL","backText":"CalculatorBack-module__backText--HKgY4","backIcon":"CalculatorBack-module__backIcon--ilpYu"};